export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m14.011 8 5.065-.003-5.065-5.073zm0-6.5L20.5 8.007V16.5c0 1.1-.889 2-1.989 2H9.49c-1.099 0-1.99-.9-1.99-2l.011-13c0-1.1.89-2 1.989-2zM3.51 5.5h2l-.01 13c0 1.1.891 2 1.99 2h9.01v2H7.49a4 4 0 0 1-3.99-4z\"/>"
};